/* MLOUYE Initial MagSafe kreatif sayfa (sections/mlouye-initial-magsafe.liquid). Prototip B6'nın canlı sürümü
   (prototip/magsafe-v1-2026-10-21/kreatif.html), yalnız kalibre telefon renkleri. Veri: [data-mim-data] JSON (Liquid).
   Görseller Shopify Files: magsafe-<H>-<renk>.png (RGBA dekupe), magsafe-telefon-<renk>.jpg + -mask.png.
   URL parametreleri: ?color=<slug>&initial=<harf>&show=phone (Shopify 'view' parametresini şablon seçici sayar; kullanılmaz). */
(() => {
  document.querySelectorAll('[data-mim]').forEach((root) => {
    let D;
    try { D = JSON.parse(root.querySelector('[data-mim-data]').textContent); } catch (e) { return; }
    if (!D.colors || !D.colors.length) return;
    const L = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
    const $ = (sel) => root.querySelector(sel);
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const q = new URLSearchParams(location.search);
    const file = (name, w) => D.files + name + (w ? '?width=' + w : '');
    const cutSrc = (l, c, w) => file(`magsafe-${l}-${c.slug}.png`, w || 900);
    const layer = (k) => D.files + `magsafe-telefon-${k}`;
    const byName = (n) => D.colors.find((c) => c.name === n);
    const start = D.colors.find((c) => c.slug === q.get('color')) || byName(D.defaultColor) || D.colors[0];
    const state = { color: start.name, idx: L.indexOf('M'), chosen: false, view: q.get('show') === 'phone' ? 'phone' : 'card', phone: 0 };
    const col = () => byName(state.color);
    const variantOf = (l, c) => (c || col()).variants[l || L[state.idx]];

    function cardEl(l, c, extra) {
      return `<div class="mim-cut mim-cut--card mim-snap${extra || ''}"><div class="mim-cut__m"><img src="${cutSrc(l, c)}" alt="${c.title}, letter ${l}, ${c.name}" width="818" height="1090" loading="lazy"></div></div>`;
    }
    function phoneEl(l, c, extra) {
      const P = D.phones[state.phone], base = layer(P.key);
      const card = `<div class="mim-card"><div class="mim-cut__m"><img src="${cutSrc(l, c)}" alt="${c.title}, letter ${l}, ${c.name}, on a ${P.name.toLowerCase()} phone" width="818" height="1090"></div></div>`;
      return `<div class="mim-onphone mim-snap${extra || ''}"><div class="mim-layer" style="-webkit-mask-image:url('${base}-mask.png');mask-image:url('${base}-mask.png')"><img src="${base}.jpg" alt="" width="572" height="1180"></div>${card}</div>`;
    }
    const settle = (el) => { const m = el.querySelector('.mim-snap-in'); if (m) requestAnimationFrame(() => requestAnimationFrame(() => m.classList.remove('mim-snap-in'))); };

    const mk = (wrap, name, items, onPick) => {
      items.forEach((c, i) => {
        const lab = document.createElement('label');
        lab.className = 'mim-c';
        lab.innerHTML = `<input type="radio" name="${name}" value="${i}"><span class="mim-c__dot" style="--c:${c.swatch || c.sw}" aria-hidden="true"></span><span class="mim-c__name">${c.name}</span>`;
        wrap.appendChild(lab);
      });
      wrap.addEventListener('change', (e) => onPick(+e.target.value));
    };
    const uid = Math.random().toString(36).slice(2, 7);
    mk($('[data-mim-colors]'), 'mim-color-' + uid, D.colors, (i) => setColor(D.colors[i].name));
    mk($('[data-mim-phones]'), 'mim-phone-' + uid, D.phones, (i) => { state.phone = i; paintPlate(false); });

    /* Makara */
    const reel = $('[data-mim-reel]');
    L.forEach((l, i) => {
      const li = document.createElement('li');
      li.id = `mim-r-${uid}-${l}`; li.setAttribute('role', 'option'); li.textContent = l; li.setAttribute('aria-selected', 'false');
      li.addEventListener('click', () => { choose(i); scrollReel(i, true); });
      reel.appendChild(li);
    });
    const itemH = () => reel.firstElementChild.getBoundingClientRect().height || 56;
    let settleT, programmatic = false;
    function scrollReel(i, smooth) { programmatic = true; reel.scrollTo({ top: i * itemH(), behavior: smooth && !reduce ? 'smooth' : 'auto' }); }
    function markReel(i) {
      [...reel.children].forEach((li, k) => { li.classList.toggle('mim-is-center', k === i); li.setAttribute('aria-selected', String(k === i && state.chosen)); li.classList.toggle('mim-is-near', Math.abs(k - i) === 1); });
      reel.setAttribute('aria-activedescendant', `mim-r-${uid}-${L[i]}`);
      $('[data-mim-ghost]').textContent = L[i];
    }
    reel.addEventListener('scroll', () => {
      const i = Math.max(0, Math.min(25, Math.round(reel.scrollTop / itemH())));
      markReel(i);
      clearTimeout(settleT);
      settleT = setTimeout(() => { if (!programmatic) choose(i); programmatic = false; }, 140);
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => reel.addEventListener(ev, () => { programmatic = false; }, { passive: true }));
    reel.addEventListener('keydown', (e) => {
      let i = state.idx;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') i = Math.min(25, i + 1);
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') i = Math.max(0, i - 1);
      else if (e.key === 'Home') i = 0; else if (e.key === 'End') i = 25;
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); return; }
      else if (/^[a-z]$/i.test(e.key)) i = L.indexOf(e.key.toUpperCase());
      else return;
      e.preventDefault(); choose(i); scrollReel(i, true);
    });
    $('[data-mim-type]').addEventListener('input', (e) => {
      const v = (e.target.value || '').toUpperCase().replace(/[^A-Z]/g, '').slice(-1);
      e.target.value = v;
      if (v) { const i = L.indexOf(v); choose(i); scrollReel(i, true); }
    });
    root.querySelectorAll('[data-mim-view]').forEach((b) => b.addEventListener('click', () => {
      state.view = b.getAttribute('data-mim-view');
      root.querySelectorAll('[data-mim-view]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      paintPlate(true);
    }));

    function paintPlate(animate) {
      const l = L[state.idx], extra = animate && !reduce ? ' mim-snap-in' : '';
      const plate = $('[data-mim-plate]');
      plate.innerHTML = state.view === 'card' ? cardEl(l, col(), extra) : phoneEl(l, col(), extra);
      settle(plate);
      $('[data-mim-phonecol]').hidden = state.view !== 'phone';
    }
    function paintFan() {
      const c = byName(D.fanColor) || col();
      $('[data-mim-fan]').innerHTML = `<div class="mim-fan">${D.fanLetters.map((l) => cardEl(l, c)).join('')}</div>`;
    }
    function paintColorBound() {
      const c = col(), sc = c.scenes || [];
      root.style.setProperty('--accent', c.accent);
      $('[data-mim-ctx]').hidden = sc.length === 0;
      $('[data-mim-ctx-title]').textContent = 'Shown in ' + c.name;
      $('[data-mim-ctx-row]').innerHTML = sc.map((s) => `<figure><img src="${s.src}" alt="${(s.alt || '').replace(/"/g, '&quot;')}" loading="lazy" width="1200" height="1500"></figure>`).join('');
    }
    function setColor(name) {
      state.color = name;
      const i = D.colors.findIndex((c) => c.name === name);
      root.querySelector(`input[name="mim-color-${uid}"][value="${i}"]`).checked = true;
      $('[data-mim-color-name]').textContent = name;
      paintPlate(true); paintColorBound(); paintBuy();
    }
    function choose(i) {
      const changed = i !== state.idx || !state.chosen;
      state.idx = i; state.chosen = true;
      markReel(i); $('[data-mim-hint]').textContent = '';
      if (changed) paintPlate(true);
      paintBuy();
    }
    function paintBuy() {
      const l = L[state.idx], v = variantOf(l), sold = state.chosen && v && !v.available;
      const atc = $('[data-mim-atc]'), atc2 = $('[data-mim-atc2]');
      atc.textContent = !state.chosen ? D.strings.select : (sold ? D.strings.soldOut : D.strings.add);
      atc.setAttribute('aria-disabled', String(!state.chosen || sold));
      atc2.textContent = state.chosen && !sold ? D.strings.add : D.strings.choose;
      $('[data-mim-bar-txt]').textContent = state.chosen ? `· ${l} · ${state.color} · ${col().price}` : `· ${col().price}`;
      const pdp = $('[data-mim-pdp]');
      if (pdp) pdp.href = col().url + (state.chosen && v ? `?variant=${v.id}` : '');
    }
    async function buy(fromBar) {
      if (!state.chosen) {
        if (fromBar) $('[data-mim-config]').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        $('[data-mim-hint]').textContent = D.strings.hint;
        reel.focus({ preventScroll: !!fromBar });
        return;
      }
      const v = variantOf();
      if (!v || !v.available) return;
      const atc = $('[data-mim-atc]');
      atc.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error('cart');
        const added = await res.json();
        if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') { location.href = `${Shopify.routes.root}cart`; return; }
        const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart } }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
      } catch (e) {
        toast(D.strings.error);
      } finally {
        atc.removeAttribute('aria-busy');
      }
    }
    $('[data-mim-atc]').addEventListener('click', () => buy(false));
    $('[data-mim-atc2]').addEventListener('click', () => buy(true));
    let tt; function toast(t) { const el = $('[data-mim-toast]'); el.textContent = t; el.classList.add('mim-is-on'); clearTimeout(tt); tt = setTimeout(() => el.classList.remove('mim-is-on'), 3200); }

    const bar = $('[data-mim-bar]'); let pastHero = false, inConfig = false;
    const sync = () => { const on = pastHero && !inConfig; bar.classList.toggle('mim-is-on', on); bar.setAttribute('aria-hidden', String(!on)); $('[data-mim-atc2]').tabIndex = on ? 0 : -1; };
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; sync(); }).observe($('.mim-hero'));
    new IntersectionObserver(([e]) => { inConfig = e.isIntersecting; sync(); }, { threshold: 0.15 }).observe($('[data-mim-config]'));

    root.querySelector(`input[name="mim-color-${uid}"][value="${D.colors.findIndex((c) => c.name === state.color)}"]`).checked = true;
    root.querySelector(`input[name="mim-phone-${uid}"][value="0"]`).checked = true;
    root.querySelectorAll('[data-mim-view]').forEach((x) => x.setAttribute('aria-pressed', String(x.getAttribute('data-mim-view') === state.view)));
    $('[data-mim-color-name]').textContent = state.color;
    markReel(state.idx); scrollReel(state.idx, false);
    paintPlate(false); paintFan(); paintColorBound(); paintBuy();
    const pre = (q.get('initial') || '').toUpperCase();
    if (L.includes(pre)) { choose(L.indexOf(pre)); scrollReel(L.indexOf(pre), false); }
  });
})();
